'use client';

import { memo, useMemo } from 'react';
import { Text, TextStyle } from 'react-native';
import { TextProps } from './Text.types';
import { applyGradientStyles } from './Text.utils';
import useStyle from '../../hooks/useStyle';
import { Variants } from './Text.content';
import { useTranslation } from '@bonanza-social/i18n';
import Animated from 'react-native-reanimated';

function CustomText({
  variant,
  locKey,
  locNS,
  gradient,
  children,
  onPress,
  numberOfLines,
  animatedStyle,
  nested,
  crossedOut,
  uppercase,
  underline,
  ...rest
}: TextProps) {
  const [t] = useTranslation(locNS);
  const style = useStyle<TextStyle>({
    ...rest,
    ...Variants[variant],
    ...(crossedOut && { textDecorationLine: 'line-through' }),
    ...(uppercase && { textTransform: 'uppercase' }),
    ...(underline && { textDecorationLine: 'underline' }),
  });
  const combinedStyle = useMemo(
    () => (gradient ? { ...style, ...applyGradientStyles(gradient) } : style),
    [gradient, style],
  );
  const Component = animatedStyle ? Animated.Text : Text;

  return (
    <Component
      key={gradient}
      style={animatedStyle ? [combinedStyle, animatedStyle] : combinedStyle}
      onPress={onPress}
      allowFontScaling={false}
      numberOfLines={numberOfLines}
      testID={`text-component`}
    >
      {children || t(locKey || '')}
    </Component>
  );
}

export default memo(CustomText);
